/* eslint-disable react-hooks/exhaustive-deps */
import assets from "assets";
import React from "react";
import styled from "styled-components";

const MaintenanceTopBanner = ({setShowMaintenanceBanner,showMaintenanceBanner}) => {

  return (
    <Container>
      <div className="banner-container">
        <span style={{ width: "100%" }}>
          Image Generation services are currently under repair. Service will be
          restored shortly.
        </span>

        <img
          onClick={() => {
            setShowMaintenanceBanner(false);
          }}
          className="close-btn"
          src={assets.grayClose}
          alt=""
        />
      </div>
    </Container>
  );
};

export default MaintenanceTopBanner;

const Container = styled.div`
  padding: 12px;
  width: 100%;
  & .banner-container {
    height: 60px;
    position: relative;
    background-color: #35363a;
    border-radius: 12px;
    border: 2px solid #494c54;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;

    span {
      font-family: Poppins;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;
      text-align: center;
    }

    button {
      background-color: #ff434e;
      height: 42px;
      width: 120px;
      border: 1px solid #71262a;
      border-radius: 8px;
      font-family: Poppins;
      font-weight: 500;
      font-size: 15px;
      line-height: 22.5px;
      color: #ffffff;
      outline: none;
    }

    & .close-btn {
      position: absolute;
      top: 0px;
      right: 30px;
      transform: translate(15px, 60%);
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 1000px) {
    & .banner-container {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      padding: 8px 35px 8px 12px;

      span {
        font-family: Poppins;
        font-weight: 400;
        font-size: 15px;
        line-height: 22.5px;
        color: #ffffff;
        width: 60%;
        padding: 5px 0px;
      }

      button {
        height: 42px;
        width: 130px;
        padding: 10px;
        border-radius: 8px;
        font-family: Poppins;
        font-weight: 500;
        font-size: 15px;
        line-height: 22.5px;
        color: #ffffff;
        outline: none;
        display: inline;
      }
    }

    & .close-btn {
      transform: translate(25px, 60%) !important;
    }
  }
`;
